import api from '@/services/contact/service';
import {
  subscribeNewsletterRequest,
  submitContactFormRequest
} from '@/services/contact/requests';
import * as types from './mutation-types';
import handleErrors from '@/utils/handler-errors';
import * as messages from '@/utils/error-messages';

export async function subscribeNewsletter({ commit, state }, data) {
  const request = subscribeNewsletterRequest(data);
  await api.subscribeNewsletter(request);
}

export async function submitContactForm({ commit, state }, data) {
  const request = submitContactFormRequest(data);
  await api.submitContactForm(request).then((response) => {
    commit(types.RESPONSE, response);
  }).catch(() => {
    handleErrors(messages.MESSAGE_1);
  });
}

export default {
  subscribeNewsletter,
  submitContactForm
};



// WEBPACK FOOTER //
// src/store/modules/contact/actions.js